import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/templates/DocumentTemplate.js";
import BanksComponentValidation from './banksComponentValidation.mdx';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Item = makeShortcode("Item");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <Item title='handleBankFilterChange(filter: string)' mdxType="Item">
      <p>{`Update component with the given bank filter. Doing so will cause a call to `}<a parentName="p" {...{
          "href": "/docs/sdk/react-native/2.x.x/primerHeadlessUniversalCheckout/componentWithRedirect/componentWithRedirectManagerProvide#parameters.props-properties.onStep"
        }}>{`onStep`}</a>{` with the filtered bank list. `}</p>
      <BanksComponentValidation mdxType="BanksComponentValidation" />
    </Item>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      